export default {
  PRODUCT_CENTER: 'https://project.hrtps.com',
  baseURL: 'https://coach-api.aivals.com/gateway',
  COS: {
    bucket: 'chatbot-prod-1256119856',
    region: 'ap-shanghai'
  }
};
